<template>
    <header
        class="md-header broker"
        :class="[
            {
                transparent: realTransparent && !showCloseIcon,
                hide: hide
            },
            pageClass,
            isMobileSize ? 'mobile' : 'pc'
        ]"
        v-show="showHeader"
        :style="adaptiveLogoStyle"
    >
        <div
            ref="nav"
            class="header-container"
            role="navigation"
            :style="mainText"
            :class="{
                nosticky: noSticky,
                'side-menu-show': sideMenuShow
            }"
        >
            <div class="social-container">
                <div class="contact-container">
                    <a
                        :href="'tel:' + agent.phone"
                        class="phone-container"
                        target="_top"
                        v-if="agent && agent.phone"
                        rel="noopener noreferrer"
                    >
                        <span
                            class="iconfont icon-call-small icon-circle"
                        ></span>
                        <span class="des">{{
                            $ft.formatPhone(agent.phone)
                        }}</span>
                    </a>
                    <a
                        v-if="agent && agent.email"
                        :href="'mailto:' + agent.email"
                        class="email-container"
                        rel="noopener noreferrer"
                    >
                        <span
                            class="iconfont icon-agent-email icon-circle"
                        ></span>
                        <span class="des">{{ agent.email }}</span>
                    </a>
                </div>
                <div
                    v-if="socialNetworksInfo.length > 0"
                    class="share-container"
                >
                    <a
                        v-for="(social, index) in socialNetworksInfo"
                        :key="social.id + '-' + index"
                        class="share-item"
                        :href="social.url"
                        :aria-label="social.socialNetwork"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i
                            class="iconfont icon-circle"
                            :class="social.icon"
                        ></i>
                    </a>
                </div>
            </div>
            <div class="menu-container">
                <div class="header-bg" :style="{ background: bgColor }"></div>
                <div class="left-menu">
                    <menu-item
                        v-for="(menu, index) in leftMenu"
                        mainMenuClass="capitalize"
                        :key="menu.name + index"
                        :menu="menu"
                        :showMenuArrow="true"
                        arrowIcon="icon-expand"
                    ></menu-item>
                </div>
                <div class="logo-menu" :class="{ 'has-sub': hasTwoLogo }">
                    <a class="logo" :href="link" rel="noopener noreferrer">
                        <site-img
                            :src="logo || null"
                            :style="{ height: size / 100 + 'em' }"
                            :size="100"
                            dir="height"
                            @load="sizeChange(), mobileImgFontSizeRecalc()"
                            :alt="altText || defaultLogoAlt"
                        ></site-img>
                    </a>
                    <a
                        v-if="subLogo"
                        class="logo"
                        :href="subLogoLink"
                        rel="noopener noreferrer"
                    >
                        <site-img
                            :src="subLogo || null"
                            :style="{ height: subLogoSize / 100 + 'em' }"
                            :size="100"
                            dir="height"
                            @load="sizeChange(), mobileImgFontSizeRecalc()"
                            :alt="subAltText || defaultSublogoAlt"
                        ></site-img>
                    </a>
                </div>
                <div
                    class="right-menu nav-container"
                    :class="{ show: sideMenuShow }"
                >
                    <menu-item
                        v-for="(menu, index) in rightMenu"
                        mainMenuClass="capitalize"
                        :key="menu.name + (index + slice1)"
                        :menu="menu"
                        :showMenuArrow="true"
                        arrowIcon="icon-expand"
                    ></menu-item>
                    <template v-if="isMobileSize">
                        <li
                            v-if="showTranslatePlugin"
                            class="menu-item"
                            @click="showLangMenu"
                        >
                            <div class="menu-language">
                                <div class="item-name">
                                    <i class="iconfont icon-website3"></i>
                                    {{ $t('md-header.language') }}
                                </div>
                                <div class="item-label">
                                    <span v-html="currentLanguageItem.label" />
                                    <i class="iconfont icon-next-big"></i>
                                </div>
                            </div>
                        </li>
                        <li
                            v-if="showCurrency"
                            class="menu-item"
                            @click="showCurrencyMenu"
                        >
                            <div class="menu-currency">
                                <div class="item-name">
                                    <i class="iconfont icon-currency"></i>
                                    {{ $t('md-header.currency') }}
                                </div>
                                <div class="item-label">
                                    {{ currentCurrencyLabel }}
                                    <i class="iconfont icon-next-big"></i>
                                </div>
                            </div>
                        </li>
                        <closely-app-download downloadTheme="black" useModule="md-header"/>
                    </template>
                    <li
                        class="menu-item more"
                        :class="{ 'has-child': moreShow }"
                        v-show="moreMenu.length"
                        @mouseenter="calcMoreStyle"
                    >
                        <a
                            class="iconfont icon-more"
                            style="font-size: 1.33em"
                            role="button"
                            tabindex="0"
                            :aria-label="$t('md-header.more')"
                            rel="noopener noreferrer"
                        ></a>
                        <div class="submenu-container">
                            <div class="wrapper" ref="wrapper">
                                <ol
                                    :style="moreStyle"
                                    class="submenu hidden-scrollbar"
                                >
                                    <menu-item
                                        v-for="(menu, index) in moreMenu"
                                        mainMenuClass="capitalize"
                                        :key="menu.name + index"
                                        :menu="menu"
                                        isMore
                                        :showMenuArrow="true"
                                        arrowIcon="icon-expand"
                                        ref="moreMenu"
                                    ></menu-item>
                                </ol>
                            </div>
                        </div>
                    </li>
                    <!-- google translate start -->
                    <template v-if="!isMobileSize">
                        <ul
                            v-if="showTranslatePlugin"
                            class="head-language-pc language"
                        >
                            <menu-item
                                mainMenuClass="capitalize"
                                :menu="translateMenu"
                                class="item-language language"
                            >
                                <template v-slot:first>
                                    <span
                                        v-html="currentLanguageItem.label"
                                    ></span>
                                    <i class="iconfont icon-expand"></i>
                                </template>
                                <template v-slot:second="slotProps">
                                    <span
                                        @click="selectLanguage(slotProps.row)"
                                        class="lang-list-item"
                                    >
                                        <span>{{ slotProps.row.label }}</span>
                                    </span>
                                </template>
                            </menu-item>
                        </ul>
                        <ul
                            v-if="showCurrency"
                            class="head-language-pc currency"
                        >
                            <menu-item
                                :menu="curencyMenu"
                                class="item-currency"
                            >
                                <template v-slot:first>
                                    <span>{{ currentCurrencyLabel }}</span>
                                    <i class="iconfont icon-expand"></i>
                                </template>
                                <template v-slot:second="slotProps">
                                    <span
                                        @click="selectCurrency(slotProps.row)"
                                        class="lang-list-item"
                                    >
                                        <span
                                        >{{ slotProps.row.abbr }}({{
                                            slotProps.row.symbol
                                        }})-{{ slotProps.row.name }}</span
                                        >
                                        <em
                                            v-show="
                                                currentCurrency ==
                                                    slotProps.row.abbr
                                            "
                                            class="iconfont icon-checked-light"
                                        ></em>
                                    </span>
                                </template>
                            </menu-item>
                        </ul>
                    </template>
                    <!-- google translate end -->
                    <ul class="head-account">
                        <!--  Has logged   Display user related information  start -->
                        <li v-if="user" class="menu-item has-child">
                            <a
                                class="menu-user"
                                @click="hideMenu"
                                href="/profile"
                                rel="noopener noreferrer"
                            >
                                <span
                                    class="menu-user-initial"
                                    :style="{ background: userBackgroundColor }"
                                >{{ initialFirstName }}</span
                                >
                                <span
                                    v-if="isMobileSize"
                                    class="first-name"
                                >{{ user.firstName }}</span
                                >
                            </a>
                            <div class="wrapper">
                                <ol class="submenu">
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=MyHomes"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.myHomes') }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=MyTour"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.myTour') }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=Favorites"
                                            rel="noopener noreferrer"
                                        >{{
                                            $t('md-header.myFavorites')
                                        }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=Searches"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.mySearches') }}</a
                                        >
                                    </li>
                                    <li class="menu-item">
                                        <a
                                            href="/profile?type=Account"
                                            rel="noopener noreferrer"
                                        >{{
                                            $t('md-header.accountSettings')
                                        }}</a
                                        >
                                    </li>
                                    <li v-if="user.isOwner" class="menu-item">
                                        <a
                                            href="/admin/home"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.chimeCrm') }}</a
                                        >
                                    </li>
                                    <closely-app-download useModule="md-header" class="parent-of-closely" />
                                    <li class="menu-item">
                                        <a
                                            @click.prevent="logout"
                                            rel="noopener noreferrer"
                                        >{{ $t('md-header.signOut') }}</a
                                        >
                                    </li>
                                </ol>
                            </div>
                            <span
                                v-show="isMobileSize"
                                @click="logout"
                            >{{ $t('md-header.signOut') }}</span
                            >
                        </li>
                        <!--  Has logged   Display user related information  end -->

                        <!--  not logged in   Show Login Register  start -->
                        <template v-else>
                            <li class="menu-item item-regist" @click="register" role="button" tabindex="0">
                                {{ $t('md-header.register') }}
                            </li>
                            <span v-if="!isMobileSize" class="vertical-in-menu"
                            >/</span
                            >
                            <li class="menu-item item-login" @click="signIn" role="button" tabindex="0">
                                {{ $t('md-header.signIn') }}
                            </li>
                        </template>
                        <!--  not logged in   Show Login Register  end -->
                    </ul>
                </div>
                <!-- mobile language nav start -->
                <div
                    class="nav-container language"
                    :style="mainText"
                    v-if="isMobileSize && showTranslatePlugin"
                    :class="{ show: showMobileLangMenu }"
                >
                    <ul class="head-language-mobile">
                        <menu-item
                            class="item-language language"
                            v-for="lang in translateMenu.items"
                            mainMenuClass="capitalize"
                            :key="lang.name"
                            :menu="{}"
                            :class="{ active: currentLanguage === lang.name }"
                        >
                            <template v-slot:first>
                                <span
                                    class="lang-list-item"
                                    @click="selectLanguage(lang)"
                                >
                                    <span>{{ lang.label }}</span>
                                </span>
                            </template>
                        </menu-item>
                    </ul>
                </div>
                <!-- mobile language nav end -->
                <!-- mobile currency start-->
                <div
                    class="nav-container language"
                    :style="mainText"
                    v-if="isMobileSize && showCurrency"
                    :class="{ show: showMobileCurrencyMenu }"
                >
                    <ul class="head-language-mobile">
                        <menu-item
                            class="item-language currency"
                            v-for="currency in curencyMenu.items"
                            mainMenuClass="capitalize"
                            :key="currency.abbr"
                            :menu="{}"
                            :class="{
                                active: currentCurrency === currency.abbr
                            }"
                        >
                            <template v-slot:first>
                                <span
                                    class="lang-list-item"
                                    @click="selectCurrency(currency)"
                                >
                                    <span
                                    >{{ currency.abbr }}({{
                                        currency.symbol
                                    }})-{{ currency.name }}</span
                                    >
                                </span>
                            </template>
                        </menu-item>
                    </ul>
                </div>
                <!-- mobile currency end-->
                <div
                    class="nav-mask"
                    @click="closeAllMenu"
                    @touchmove.self.prevent
                ></div>
                <div
                    v-show="showCloseIcon"
                    class="iconfont icon-close-light"
                    @click="closeAllMenu"
                ></div>
                <div
                    v-show="!showCloseIcon && isMobileSize"
                    class="iconfont icon-more"
                    @click="calcAndShowMenu"
                ></div>
            </div>
        </div>
        <div v-show="!isOverlap" class="header-placeholder">
            <div class="top" style="height: 50px" />
            <div class="bottom" :style="{ height: overlapSize + 'em' }" />
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </header>
</template>

<script>
import Common from '../index';
import centerLogo from '../centerLogo';
import scroll from '../scroll';
export default {
    mixins: [Common, centerLogo, scroll],
    data: function() {
        return {
            navTop: true,
            useHide: true
        };
    },
    computed: {
        hasTwoLogo() {
            return this.logo && this.subLogo;
        },
        noSticky({ isDetail, sticky, isOverlap }) {
            return isDetail || (!sticky && !isOverlap);
        }
    },
    methods: {
        calcAndShowMenu() {
            // CHIME-23239
            if (this.noSticky) {
                const navEle = this.$el.querySelector('.nav-container');
                navEle.style.top = `calc(var(--header-top, 50px) - ${window.scrollY}px - 1px)`;
            }
            this.showMenu();
        },
        sizeChange() {
            // this.isLarger = window.innerWidth >= 1000; 
            this.calculateSlice();
        },
        beforePageScroll() {
            return this.sideMenuShow;
        }
    },
    watch: {
        // isLarger(value) {
        //     if (value) {
        //         setTimeout(() => {
        //             const navEle = this.$el.querySelector('.nav-container');
        //             navEle.style.display = 'flex';
        //         });
        //     }
        // }
    }
};
</script>
<style lang="scss">
@import './index.scss';
@import './pc.scss';
@import './mobile.scss';
</style>
